import { Component, ElementRef, EventEmitter, Output, ViewChild, OnInit, Input } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, AuthService, ConfigService, MessageService, ButtonLoader } from '../../../../../core';
import { ConfigEmpresa } from '../../../../configuracoes/app/empresa';
import { ClienteNomePipe } from '../../../../pessoa/cliente/pipes';
import { ClienteAnaliseMercadoProjecaoPerda } from '../cliente-analise-mercado-projecao-perda';
import { ClienteAnaliseMercadoProjecaoHttpService } from '../../services';
import { MotivoPerdaVenda, MotivoPerdaVendaCrudHttpService, MotivoPerdaVendaSearchFilter } from '../../../../motivo-perda-venda';
import { ClienteAnaliseMercadoProjecaoSearch } from '../../cliente-analise-mercado-projecao-search';
import { ClienteAnaliseMercadoProjecaoClassificacaoSearch, ClienteAnaliseMercadoProjecaoClassificacaoHttpService } from '../../classificacao';

@Component({
    selector: 'sgt-cliente-analise-mercado-projecao-perda-modal',
    templateUrl: './cliente-analise-mercado-projecao-perda-modal.component.html',
    styleUrls: ['./cliente-analise-mercado-projecao-perda-modal.component.less']
})
export class ClienteAnaliseMercadoProjecaoPerdaModalComponent implements OnInit {
    configEmpresa: ConfigEmpresa;
    isRepresentante: boolean;

    elModal: any;
    editMode: boolean;
    entity: ClienteAnaliseMercadoProjecaoPerda;

    /** Projeções das classificações */
    classificacoes: ClienteAnaliseMercadoProjecaoClassificacaoSearch[];
    /** Indicador se está carregando as projeções das classificações */
    isLoadingClassificacoes: boolean;
    /** Indicador se já carregou as projeções das classificações */
    isLoadedClassificacoes: boolean;

    @Output() cancel = new EventEmitter<ClienteAnaliseMercadoProjecaoPerda>();
    @Output() afterUpdatePerda = new EventEmitter<ClienteAnaliseMercadoProjecaoSearch>();
    @ViewChild('form') form: NgForm;

    motivosPerdas: MotivoPerdaVenda[];

    constructor(private el: ElementRef,
                private authService: AuthService,
                private configService: ConfigService,
                private messageService: MessageService,
                private clienteNomePipe: ClienteNomePipe,
                private motivoPerdaVendaCrudHttpService: MotivoPerdaVendaCrudHttpService,
                private clienteAnaliseMercadoProjecaoHttpService: ClienteAnaliseMercadoProjecaoHttpService,
                private clienteAnaliseMercadoProjecaoClassificacaoHttpService: ClienteAnaliseMercadoProjecaoClassificacaoHttpService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.isRepresentante = this.authService.isRepresentante();

        this.create();
        this.searchMotivosPerdas();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                jQuery('#motivoPerdaProjecaoUpdate').trigger('focus');

                // Pesquisando as projeções mensais das classificações do cliente que estão sendo perdidas
                this.searchClassificacoes();

                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                this.clear()
                e.stopPropagation();
            });
    }

    /** Pesquisa os motivos de perdas cadastrados */
    private searchMotivosPerdas() {
        this.motivosPerdas = [];
        const filter = new MotivoPerdaVendaSearchFilter();
        filter.perdaVenda = true;
        this.motivoPerdaVendaCrudHttpService.searchWithFilter(filter)
            .subscribe(
                entities => this.motivosPerdas = entities,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os motivos de perdas das projeções', error)
            );
    }

    /** Obtem o motivo da perda das projeções nos motivos pesquisados através do ID informado */
    private getMotivoPerda(idMotivoPerda: number): MotivoPerdaVenda {
        return this.motivosPerdas?.find(entityFilter => entityFilter.id === idMotivoPerda);
    }

    /** Ao alterar o motivo da perda */
    onChangeMotivoPerda(idMotivoPerda: number) {
        this.entity.entityUpdatePerda.idMotivoPerdaProjetado = idMotivoPerda;
        this.entity.entityUpdatePerda.motivoPerdaProjetado = this.getMotivoPerda(idMotivoPerda);
    }

    /** Abre o modal para inserir a perda das projeções mensais do cliente */
    insert(entity: ClienteAnaliseMercadoProjecaoPerda) {
        this.editMode = false;
        this.entity = entity;

        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    /** Abre o modal para editar a perda das projeções mensais do cliente */
    edit(entity: ClienteAnaliseMercadoProjecaoPerda) {
        this.editMode = true;
        this.entity = entity;
        this.entity.entityUpdatePerda.motivoPerdaProjetado = this.getMotivoPerda(this.entity.entityUpdatePerda.idMotivoPerdaProjetado);

        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    /** Pesquisa as projeções mensais das classificações do cliente que estão sendo perdidas */
    private searchClassificacoes() {
        this.isLoadingClassificacoes = true;
        this.isLoadedClassificacoes = false;
        this.clienteAnaliseMercadoProjecaoClassificacaoHttpService.search(this.entity.entityUpdatePerda.idCliente, this.entity.entityUpdatePerda.mes, this.entity.entityUpdatePerda.ano, this.entity.entityUpdatePerda.statusProjetadoAtual, this.entity.entityUpdatePerda.idEtapaNegociacaoProjecaoAtual)
            .subscribe(
                entities => {
                    this.classificacoes = entities;
                    this.isLoadingClassificacoes = false;
                    this.isLoadedClassificacoes = true;
                },
                (error: ApiError) => {
                    this.messageService.error(error.message,  'Erro ao pesquisar as projeções dos segmentos', error);
                    this.isLoadingClassificacoes = false;
                    this.classificacoes = [];
                }
            );
    }

    /** Limpas as variáveis utilizadas no modal */
    private clear() {
        this.entity = null;
        this.classificacoes = null;
        this.isLoadingClassificacoes = false;
        this.isLoadedClassificacoes = false;
    }

    /** Reseta o form e fecha o modal */
    private close() {
        // this.form?.reset();
        this.elModal.modal('hide');
    }

    /** Cancela a perda das projeções mensais do cliente */
    cancelClick() {
        this.cancel.emit(this.entity);
        this.close();
    }

    /** Atualiza o status projetado das projeções mensais do cliente para perdido **/
    update() {
        const btn = new ButtonLoader('#btnClienteAnaliseMercadoProjecaoUpdatePerdida');
        btn.loading(this.editMode ? 'Atualizando' : 'Confirmando');
        this.clienteAnaliseMercadoProjecaoHttpService.updateStatusProjecoesCliente(this.entity.entityUpdatePerda)
            .subscribe(
                projecao => {
                    this.messageService.success('', this.editMode  ? `Informações das perdas das projeções do cliente ${this.clienteNomePipe.transform(this.entity.nomeCliente, this.entity.nomeFantasiaCliente, this.entity.codigoIntegracaoErpCliente, this.entity.tipoPessoa)} atualizadas com sucesso` : `Perdas das projeções do cliente ${this.clienteNomePipe.transform(this.entity.nomeCliente, this.entity.nomeFantasiaCliente, this.entity.codigoIntegracaoErpCliente, this.entity.tipoPessoa)} confirmadas com sucesso`);
                    this.afterUpdatePerda.emit(projecao);
                    btn.reset();
                    this.close();
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, this.editMode ? `Erro ao atualizar as informações das perdas das projeções do cliente ${this.clienteNomePipe.transform(this.entity.nomeCliente, this.entity.nomeFantasiaCliente, this.entity.codigoIntegracaoErpCliente, this.entity.tipoPessoa)}` : `Erro ao confirmar as perdas das projeções do cliente ${this.clienteNomePipe.transform(this.entity.nomeCliente, this.entity.nomeFantasiaCliente, this.entity.codigoIntegracaoErpCliente, this.entity.tipoPessoa)}`, error);
                    btn.reset();
                }
            );
    }
}
